import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

// Extend Window interface to include gtag
declare global {
    interface Window {
        gtag?: (command: string, targetId: string, config?: any) => void;
    }
}

export default function useAnalytics() {
    const location = useLocation();
    const lastPath = useRef<string | null>(null);

    useEffect(() => {
        if (typeof window.gtag !== "function") return;
        const path = location.pathname + location.search;
        if (lastPath.current === path) return;   // evita duplicado em dev
        lastPath.current = path;

        window.gtag("event", "page_view", {
            page_title: document.title,
            page_path: path,
            page_location: window.location.href,
        });
    }, [location]);
}

